<template>
  <modal
    name="BDC_LAYOUT"
    width="98%"
    height="90%"
    :scrollable="false"
    :clickToClose="false"
  >
    <div class="layout-configurator">
      <!-- Header -->
      <div class="config-header">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h2>
              <i class="fas fa-cog mr-2"></i>
              Configurador de Layout
            </h2>
            <p>
              {{
                parametro
                  ? parametro.desc
                  : "Configure a aparência e comportamento do seu site"
              }}
            </p>
          </div>
          <div>
            <div class="config-footer">
              <button class="btn btn-primary" @click="updateparametro(parametro)">
                <i class="fas fa-save mr-2"></i>
                Salvar Configurações
              </button>
              <button class="btn btn-secondary" @click="close">
                <i class="fas fa-times mr-2"></i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="config-sections">
        <!-- Navigation Sidebar -->
        <div class="sections-nav">
          <button
            v-for="section in sections"
            :key="section.id"
            class="section-item"
            :class="{ active: activeSection === section.id }"
            @click="activeSection = section.id"
          >
            <i :class="section.icon + ' section-icon'"></i>
            {{ section.name }}
          </button>
        </div>

        <!-- Configuration Area -->
        <div class="section-content">
          <!-- Cabeçalho Section -->
          <div v-if="activeSection === 'header'">
            <div class="section-description">
              <i class="fas fa-info-circle mr-2"></i>
              Configure o cabeçalho do seu site, incluindo pré-cabeçalho e tipo
              de cabeçalho principal.
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4>
                  <i class="fas fa-window-maximize mr-2"></i>Pré-cabeçalho
                </h4>
              </div>
              <div class="config-card-body">
                <TIPO_PRE_CABECALHO v-model="parametro.valor" />
              </div>
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-header mr-2"></i>Tipo de Cabeçalho</h4>
              </div>
              <div class="config-card-body">
                <TIPO_CABECALHO v-model="parametro.valor" />
              </div>
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4>
                  <i class="fas fa-exclamation-triangle mr-2"></i>Aviso de Login
                </h4>
              </div>
              <div class="config-card-body">
                <TEXT_COMPONENT
                  v-model="parametro.valor"
                  config="AVISO_LOGIN"
                  label="Texto de aviso localizado abaixo do login"
                />
              </div>
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-phone mr-2"></i>Ação no Cabeçalho</h4>
              </div>
              <div class="config-card-body">
                <LINK_PARA_ACAO v-model="parametro.valor" />
              </div>
            </div>
          </div>

          <!-- Menu Section -->
          <div v-if="activeSection === 'menu'">
            <div class="section-description">
              <i class="fas fa-info-circle mr-2"></i>
              Escolha o tipo de menu que melhor se adapta ao seu site e
              configure suas opções.
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-bars mr-2"></i>Tipo de Menu</h4>
              </div>
              <div class="config-card-body">
                <TIPO_MENU v-model="parametro.valor" />
              </div>
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-cog mr-2"></i>Configurações do Menu</h4>
              </div>
              <div class="config-card-body">
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="USA_MENU_LATERAL"
                  label="Menu lateral na página inicial"
                />
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="ICONE_MENU_TAMANHO_FIXO"
                  label="Ícones com tamanho fixo"
                />
              </div>
            </div>
          </div>

          <!-- Rodapé Section -->
          <div v-if="activeSection === 'footer'">
            <div class="section-description">
              <i class="fas fa-info-circle mr-2"></i>
              Configure o rodapé do seu site e suas funcionalidades.
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4>
                  <i class="fas fa-window-minimize mr-2"></i>Tipo de Rodapé
                </h4>
              </div>
              <div class="config-card-body">
                <TIPO_RODAPE v-model="parametro.valor" />
              </div>
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4>
                  <i class="fas fa-building mr-2"></i>Nome da filial no rodapé
                </h4>
              </div>
              <div class="config-card-body">
                <TIPO_NOME_FILIAL_RODAPE v-model="parametro.valor" />
              </div>
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-layer-group mr-2"></i>Pré-rodapé</h4>
              </div>
              <div class="config-card-body">
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="USA_PRE_RODAPE"
                  label="Usar itens no pré-rodapé"
                />
              </div>
            </div>
          </div>

          <!-- Marcas Section -->
          <div v-if="activeSection === 'brands'">
            <div class="section-description">
              <i class="fas fa-info-circle mr-2"></i>
              Configure como as marcas são exibidas no seu site.
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4>
                  <i class="fas fa-shopping-cart mr-2"></i>Compra por Marca
                </h4>
              </div>
              <div class="config-card-body">
                <TIPO_COMPRE_MARCA v-model="parametro.valor" />
              </div>
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-adjust mr-2"></i>Efeitos Visuais</h4>
              </div>
              <div class="config-card-body">
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="USAR_EFEITO_PB_MARCAS"
                  label="Efeito Preto/Branco nas marcas"
                />
              </div>
            </div>
          </div>

          <!-- Tintométrico Section -->
          <div v-if="activeSection === 'tintometrico'">
            <div class="section-description">
              <i class="fas fa-info-circle mr-2"></i>
              Configure onde o cliente acessa o tintométrico no site. As opções
              só têm efeito para clientes com o módulo Tintométrico contratado.
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-paint-roller mr-2"></i>Pontos de acesso</h4>
              </div>
              <div class="config-card-body">
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="USA_TINTOMETRICO_HOME"
                  label="Card de destaque na página inicial"
                />
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="USA_TINTOMETRICO_HEADER"
                  label="Botão no cabeçalho"
                />
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="USA_TINTOMETRICO_MENU_LATERAL"
                  label="Item no menu lateral"
                />
              </div>
            </div>
          </div>

          <!-- Layout Section -->
          <div v-if="activeSection === 'layout'">
            <div class="section-description">
              <i class="fas fa-info-circle mr-2"></i>
              Configure aspectos gerais do layout e comportamento do site.
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-image mr-2"></i>Banner e Imagens</h4>
              </div>
              <div class="config-card-body">
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="BANNER_TOPO_FULLSCREEN"
                  label="Banner com largura total"
                />
              </div>
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-lock mr-2"></i>Cabeçalho e Navegação</h4>
              </div>
              <div class="config-card-body">
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="CABECALHO_FIXO"
                  label="Cabeçalho fixo"
                />
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="EXIBE_COMPRADOR_HEADER"
                  label="Exibir comprador no cabeçalho"
                />
              </div>
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-user-shield mr-2"></i>Área Restrita</h4>
              </div>
              <div class="config-card-body">
                <BOOLEAN_COMPONENT
                  v-model="parametro.valor"
                  config="USA_AREA_RESTRITA"
                  label="Usar área restrita"
                />
              </div>
            </div>
          </div>

          <!-- Aplicativo Section -->
          <div v-if="activeSection === 'app'">
            <div class="section-description">
              <i class="fas fa-info-circle mr-2"></i>
              Configure integrações com aplicativos móveis e outras plataformas.
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-mobile-alt mr-2"></i>Aplicativo B2B</h4>
              </div>
              <div class="config-card-body">
                <TEXT_COMPONENT
                  v-model="parametro.valor"
                  config="APP_URL"
                  label="Link do aplicativo B2B (deixe em branco para não utilizar)"
                />
              </div>
            </div>
          </div>

          <!-- Portal Section -->
          <div v-if="activeSection === 'portal'">
            <div class="section-description">
              <i class="fas fa-info-circle mr-2"></i>
              Configuração de layout exclusiva para o modo de operação Portal.
            </div>

            <div class="config-card">
              <div class="config-card-header">
                <h4><i class="fas fa-mobile-alt mr-2"></i>Layouts login</h4>
              </div>
              <div class="config-card-body">
                <TIPO_LOGIN_PORTAL v-model="parametro.valor" />
              </div>
            </div>
          </div>
        </div>

        <!-- Preview Area - Largura Total -->
        <div class="preview-section">
          <div class="preview-header">
            <h4>
              <i class="fas fa-eye mr-2"></i>
              Prévia do Site
            </h4>
          </div>

          <div class="preview-container">
            <div class="site-preview">
              <!-- Pré-cabeçalho -->
              <div
                v-if="parametro.valor.TIPO_PRE_CABECALHO"
                class="preview-pre-header"
              >
                <div class="preview-section-label">Pré-cabeçalho</div>
                <div class="preview-pre-header-content">
                  <span v-if="parametro.valor.TIPO_PRE_CABECALHO === 'TEXT'">
                    <i class="fas fa-font mr-1"></i> Texto personalizado
                  </span>
                  <span
                    v-else-if="parametro.valor.TIPO_PRE_CABECALHO === 'LINKS'"
                  >
                    <i class="fas fa-link mr-1"></i> Links úteis
                  </span>
                </div>
              </div>

              <!-- Cabeçalho com imagem real -->
              <div
                class="preview-header-section"
                :class="{ 'fixed-header': parametro.valor.CABECALHO_FIXO }"
              >
                <div class="preview-section-label">
                  Cabeçalho
                  <span
                    v-if="parametro.valor.CABECALHO_FIXO"
                    class="label-addon"
                    >(Fixo)</span
                  >
                </div>
                <div class="preview-header-image">
                  <img
                    v-if="
                      parametro.valor.TIPO_CABECALHO ===
                      'HEADER_CARRINHO_DETALHADO'
                    "
                    :src="headerImages.HEADER_CARRINHO_DETALHADO"
                    alt="Cabeçalho Detalhado"
                    class="header-preview-img"
                  />
                  <img
                    v-else-if="
                      parametro.valor.TIPO_CABECALHO ===
                      'HEADER_CARRINHO_SIMPLIFICADO'
                    "
                    :src="headerImages.HEADER_CARRINHO_SIMPLIFICADO"
                    alt="Cabeçalho Simplificado"
                    class="header-preview-img"
                  />
                  <div v-else class="header-placeholder">
                    <i class="fas fa-header fa-2x"></i>
                    <p>Selecione um tipo de cabeçalho</p>
                  </div>
                </div>

                <div
                  v-if="parametro.valor.AVISO_LOGIN"
                  class="preview-login-warning"
                >
                  <i class="fas fa-exclamation-triangle mr-1"></i>
                  {{
                    parametro.valor.AVISO_LOGIN ||
                    "Aviso de login personalizado"
                  }}
                </div>
              </div>

              <!-- Menu com imagem real -->
              <div class="preview-menu-section">
                <div class="preview-section-label">Menu</div>
                <div class="preview-menu-image">
                  <img
                    v-if="parametro.valor.TIPO_MENU === 'MENU_COM_ICONES'"
                    :src="menuImages.MENU_COM_ICONES"
                    alt="Menu com Ícones"
                    class="menu-preview-img"
                  />
                  <img
                    v-else-if="
                      parametro.valor.TIPO_MENU === 'MENU_TODOS_DEPARTAMENTOS'
                    "
                    :src="menuImages.MENU_TODOS_DEPARTAMENTOS"
                    alt="Menu Todos Departamentos"
                    class="menu-preview-img"
                  />
                  <img
                    v-else-if="
                      parametro.valor.TIPO_MENU ===
                      'MENU_DEPARTAMENTOS_ICONE_COM_TEXTO'
                    "
                    :src="menuImages.MENU_DEPARTAMENTOS_ICONE_COM_TEXTO"
                    alt="Menu Departamentos com Ícone e Texto"
                    class="menu-preview-img"
                  />
                  <div v-else class="menu-placeholder">
                    <i class="fas fa-bars fa-2x"></i>
                    <p>Selecione um tipo de menu</p>
                  </div>
                </div>
              </div>

              <!-- Conteúdo Principal -->
              <div class="preview-main-content">
                <div class="preview-section-label">Conteúdo Principal</div>

                <!-- Banner -->
                <div
                  class="preview-banner"
                  :class="{
                    'fullscreen-banner': parametro.valor.BANNER_TOPO_FULLSCREEN,
                  }"
                >
                  <div class="banner-placeholder">
                    <i class="fas fa-image fa-2x"></i>
                    <p>Banner Principal</p>
                    <small>{{
                      parametro.valor.BANNER_TOPO_FULLSCREEN
                        ? "Largura Total"
                        : "Largura Padrão"
                    }}</small>
                  </div>
                </div>

                <!-- Menu Lateral -->
                <div class="preview-content-area">
                  <div
                    v-if="parametro.valor.USA_MENU_LATERAL"
                    class="preview-sidebar"
                  >
                    <div class="sidebar-title">Menu Lateral</div>
                    <div class="sidebar-items">
                      <div class="sidebar-item">Categoria 1</div>
                      <div class="sidebar-item">Categoria 2</div>
                      <div class="sidebar-item">Categoria 3</div>
                    </div>
                  </div>

                  <div class="preview-products">
                    <div class="products-grid">
                      <div class="product-card" v-for="i in 8" :key="i">
                        <div class="product-image"></div>
                        <div class="product-info">
                          <div class="product-name">Produto {{ i }}</div>
                          <div class="product-price">R$ 299,90</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Compra por Marca com imagem real -->
                <div
                  v-if="parametro.valor.TIPO_COMPRE_MARCA"
                  class="preview-brands-section"
                >
                  <div class="preview-section-label">Compra por Marca</div>
                  <div class="preview-brands-image">
                    <img
                      v-if="
                        parametro.valor.TIPO_COMPRE_MARCA === 'MARCA_COM_BORDA'
                      "
                      :src="brandsImages.MARCA_COM_BORDA"
                      alt="Marca com Borda"
                      class="brands-preview-img"
                      :class="{
                        grayscale: parametro.valor.USAR_EFEITO_PB_MARCAS,
                      }"
                    />
                    <img
                      v-else-if="
                        parametro.valor.TIPO_COMPRE_MARCA === 'MARCA_SEM_BORDA'
                      "
                      :src="brandsImages.MARCA_SEM_BORDA"
                      alt="Marca sem Borda"
                      class="brands-preview-img"
                      :class="{
                        grayscale: parametro.valor.USAR_EFEITO_PB_MARCAS,
                      }"
                    />
                  </div>
                  <div
                    v-if="parametro.valor.TEXTO_COMPRE_MARCA"
                    class="brands-text"
                  >
                    {{ parametro.valor.TEXTO_COMPRE_MARCA }}
                  </div>
                </div>
              </div>

              <!-- Pré-rodapé -->
              <div
                v-if="parametro.valor.USA_PRE_RODAPE"
                class="preview-pre-footer"
              >
                <div class="preview-section-label">Pré-rodapé</div>
                <div class="pre-footer-content">
                  <div class="pre-footer-item">
                    <i class="fas fa-truck"></i>
                    <span>Frete Grátis</span>
                  </div>
                  <div class="pre-footer-item">
                    <i class="fas fa-shield-alt"></i>
                    <span>Compra Segura</span>
                  </div>
                  <div class="pre-footer-item">
                    <i class="fas fa-headset"></i>
                    <span>Suporte 24h</span>
                  </div>
                </div>
              </div>

              <!-- Rodapé com imagem real -->
              <div class="preview-footer-section">
                <div class="preview-section-label">Rodapé</div>
                <div class="preview-footer-image">
                  <img
                    v-if="
                      parametro.valor.TIPO_RODAPE === 'FOOTER_LINKS_SOCIAIS'
                    "
                    :src="footerImages.FOOTER_LINKS_SOCIAIS"
                    alt="Rodapé com Links Sociais"
                    class="footer-preview-img"
                  />
                  <img
                    v-else-if="
                      parametro.valor.TIPO_RODAPE ===
                      'FOOTER_LOGO_COLUNAS_LINKS'
                    "
                    :src="footerImages.FOOTER_LOGO_COLUNAS_LINKS"
                    alt="Rodapé com Logo e Colunas"
                    class="footer-preview-img"
                  />
                  <div v-else class="footer-placeholder">
                    <i class="fas fa-window-minimize fa-2x"></i>
                    <p>Selecione um tipo de rodapé</p>
                  </div>
                </div>
              </div>

              <!-- App Link -->
              <div v-if="parametro.valor.APP_URL" class="preview-app-section">
                <div class="app-download">
                  <i class="fas fa-mobile-alt mr-2"></i>
                  Baixe nosso App B2B
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import CloseModal from "../../../components/CloseModal";

// Importar as imagens
import IMG_HEADER_CARRINHO_DETALHADO from "./BDC_LAYOUT/img/HEADER_CARRINHO_DETALHADO.png";
import IMG_HEADER_CARRINHO_SIMPLIFICADO from "./BDC_LAYOUT/img/HEADER_CARRINHO_SIMPLIFICADO.png";
import IMG_FOOTER_LINKS_SOCIAIS from "./BDC_LAYOUT/img/FOOTER_LINKS_SOCIAIS.png";
import IMG_FOOTER_LOGO_COLUNAS_LINKS from "./BDC_LAYOUT/img/FOOTER_LOGO_COLUNAS_LINKS.png";
import IMG_MENU_COM_ICONES from "./BDC_LAYOUT/img/MENU_COM_ICONES.png";
import IMG_MENU_TODOS_DEPARTAMENTOS from "./BDC_LAYOUT/img/MENU_TODOS_DEPARTAMENTOS.png";
import IMG_MENU_DEPARTAMENTOS_ICONE_COM_TEXTO from "./BDC_LAYOUT/img/MENU_DEPARTAMENTOS_ICONE_COM_TEXTO.png";
import IMG_MARCA_COM_BORDA from "./BDC_LAYOUT/img/MARCA_COM_BORDA.png";
import IMG_MARCA_SEM_BORDA from "./BDC_LAYOUT/img/MARCA_SEM_BORDA.png";

/** Componentes */
import TIPO_PRE_CABECALHO from "./BDC_LAYOUT/components/TIPO_PRE_CABECALHO";
import TIPO_CABECALHO from "./BDC_LAYOUT/components/TIPO_CABECALHO";
import TIPO_MENU from "./BDC_LAYOUT/components/TIPO_MENU";
import TIPO_RODAPE from "./BDC_LAYOUT/components/TIPO_RODAPE";
import TIPO_NOME_FILIAL_RODAPE from "./BDC_LAYOUT/components/TIPO_NOME_FILIAL_RODAPE";
import TIPO_COMPRE_MARCA from "./BDC_LAYOUT/components/TIPO_COMPRE_MARCA";
import LINK_PARA_ACAO from "./BDC_LAYOUT/components/LINK_PARA_ACAO";
import TIPO_LOGIN_PORTAL from "./BDC_LAYOUT/components/TIPO_LOGIN_PORTAL";
import APP_URL from "./BDC_LAYOUT/components/APP_URL";

/** Components Comuns */
import BOOLEAN_COMPONENT from "./BDC_LAYOUT/components/BOOLEAN_COMPONENT";
import TEXT_COMPONENT from "./BDC_LAYOUT/components/TEXT_COMPONENT";

export default {
  name: "BDC_LAYOUT",
  props: ["update", "close", "parametro"],
  components: {
    CloseModal,
    BOOLEAN_COMPONENT,
    TEXT_COMPONENT,
    TIPO_NOME_FILIAL_RODAPE,
    TIPO_PRE_CABECALHO,
    TIPO_CABECALHO,
    TIPO_MENU,
    TIPO_RODAPE,
    TIPO_COMPRE_MARCA,
    LINK_PARA_ACAO,
    TIPO_LOGIN_PORTAL,
    APP_URL,
  },
  data() {
    return {
      activeSection: "header",
      headerImages: {
        HEADER_CARRINHO_DETALHADO: IMG_HEADER_CARRINHO_DETALHADO,
        HEADER_CARRINHO_SIMPLIFICADO: IMG_HEADER_CARRINHO_SIMPLIFICADO,
      },
      footerImages: {
        FOOTER_LINKS_SOCIAIS: IMG_FOOTER_LINKS_SOCIAIS,
        FOOTER_LOGO_COLUNAS_LINKS: IMG_FOOTER_LOGO_COLUNAS_LINKS,
      },
      menuImages: {
        MENU_COM_ICONES: IMG_MENU_COM_ICONES,
        MENU_TODOS_DEPARTAMENTOS: IMG_MENU_TODOS_DEPARTAMENTOS,
        MENU_DEPARTAMENTOS_ICONE_COM_TEXTO:
          IMG_MENU_DEPARTAMENTOS_ICONE_COM_TEXTO,
      },
      brandsImages: {
        MARCA_COM_BORDA: IMG_MARCA_COM_BORDA,
        MARCA_SEM_BORDA: IMG_MARCA_SEM_BORDA,
      },
      sections: [
        {
          id: "header",
          name: "Cabeçalho",
          icon: "fas fa-window-maximize",
        },
        {
          id: "menu",
          name: "Menu",
          icon: "fas fa-bars",
        },
        {
          id: "footer",
          name: "Rodapé",
          icon: "fas fa-window-minimize",
        },
        {
          id: "brands",
          name: "Marcas",
          icon: "fas fa-tags",
        },
        {
          id: "tintometrico",
          name: "Tintométrico",
          icon: "fas fa-paint-roller",
        },
        {
          id: "layout",
          name: "Layout Geral",
          icon: "fas fa-th-large",
        },
        {
          id: 'app',
          name: 'Aplicativo',
          icon: 'fas fa-mobile-alt'
        },
        {
          id: 'portal',
          name: 'Modo Portal',
          icon: 'fas fa-mobile-alt'
        }

      ]
    }
  },
  methods: {
    updateparametro() {
      this.update(this.parametro);
    },
  },
};
</script>

<style scoped>
.layout-configurator {
  background: #f8f9fa;
  min-height: 100vh;
  padding: 0;
}

.config-header {
  background: white;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 0;
}

.config-header h2 {
  margin: 0;
  color: #495057;
  font-weight: 600;
  font-size: 24px;
}

.config-header p {
  margin: 5px 0 0 0;
  color: #6c757d;
  font-size: 14px;
}

.config-sections {
  display: flex;
  height: calc(100vh - 140px);
}

.sections-nav {
  width: 200px;
  background: white;
  border-right: 1px solid #e9ecef;
  padding: 20px 0;
  flex-shrink: 0;
}

.section-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  color: #495057;
  font-size: 14px;
}

.section-item:hover {
  background-color: #f8f9fa;
  color: #3a3e81;
}

.section-item.active {
  background-color: #3a3e81;
  color: white;
  border-right: 3px solid #3a3e81;
}

.section-icon {
  width: 16px;
  height: 16px;
  margin-right: 12px;
  flex-shrink: 0;
}

.section-content {
  width: 400px;
  padding: 20px;
  overflow-y: auto;
  background: #f8f9fa;
  flex-shrink: 0;
}

.preview-section {
  flex: 1;
  background: white;
  border-left: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
}

.preview-header {
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.preview-header h4 {
  margin: 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
}

.preview-container {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background: #f8f9fa;
}

.site-preview {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 100%;
}

.preview-section-label {
  background: #3a3e81;
  color: white;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.label-addon {
  font-size: 10px;
  opacity: 0.8;
}

.preview-pre-header {
  border-bottom: 1px solid #e9ecef;
}

.preview-pre-header-content {
  padding: 8px 16px;
  background: #f8f9fa;
  font-size: 12px;
  color: #6c757d;
}

.preview-header-section {
  border-bottom: 2px solid #e9ecef;
}

.preview-header-image {
  position: relative;
}

.header-preview-img {
  width: 100%;
  height: auto;
  display: block;
  max-height: 120px;
  object-fit: cover;
}

.header-placeholder {
  padding: 40px;
  text-align: center;
  color: #6c757d;
  background: #f8f9fa;
}

.header-placeholder i {
  margin-bottom: 10px;
}

.preview-login-warning {
  padding: 8px 16px;
  background: #fff3cd;
  color: #856404;
  font-size: 12px;
  border-top: 1px solid #ffeaa7;
}

.preview-menu-section {
  border-bottom: 1px solid #e9ecef;
}

.preview-menu-image {
  position: relative;
}

.menu-preview-img {
  width: 100%;
  height: auto;
  display: block;
  max-height: 100px;
  object-fit: cover;
}

.menu-placeholder {
  padding: 30px;
  text-align: center;
  color: #6c757d;
  background: #f8f9fa;
}

.menu-placeholder i {
  margin-bottom: 10px;
}

.preview-main-content {
  min-height: 300px;
}

.preview-banner {
  margin: 16px;
  border-radius: 8px;
  overflow: hidden;
}

.fullscreen-banner {
  margin: 16px 0;
  border-radius: 0;
}

.banner-placeholder {
  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);
  padding: 40px;
  text-align: center;
  color: #6c757d;
}

.preview-content-area {
  display: flex;
  padding: 16px;
  gap: 16px;
}

.preview-sidebar {
  width: 200px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

.sidebar-title {
  font-weight: 600;
  margin-bottom: 12px;
  color: #495057;
  font-size: 14px;
}

.sidebar-item {
  padding: 8px 0;
  font-size: 13px;
  color: #6c757d;
  border-bottom: 1px solid #e9ecef;
}

.preview-products {
  flex: 1;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
}

.product-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.product-image {
  height: 100px;
  background: #f8f9fa;
}

.product-info {
  padding: 12px;
}

.product-name {
  font-size: 12px;
  color: #495057;
  margin-bottom: 4px;
}

.product-price {
  font-size: 14px;
  font-weight: 600;
  color: #3a3e81;
}

.preview-brands-section {
  margin: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
}

.preview-brands-image {
  margin-top: 12px;
}

.brands-preview-img {
  width: 100%;
  height: auto;
  display: block;
  max-height: 120px;
  object-fit: cover;
  border-radius: 6px;
}

.brands-preview-img.grayscale {
  filter: grayscale(100%);
}

.brands-text {
  margin-top: 12px;
  font-size: 14px;
  color: #6c757d;
  text-align: center;
  padding: 12px;
  background: white;
  border-radius: 6px;
}

.preview-pre-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.pre-footer-content {
  display: flex;
  justify-content: space-around;
  padding: 20px;
}

.pre-footer-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #6c757d;
}

.pre-footer-item i {
  font-size: 24px;
  color: #3a3e81;
}

.preview-footer-section {
  background: #343a40;
  color: white;
}

.preview-footer-image {
  position: relative;
}

.footer-preview-img {
  width: 100%;
  height: auto;
  display: block;
  max-height: 150px;
  object-fit: cover;
}

.footer-placeholder {
  padding: 40px;
  text-align: center;
  color: #adb5bd;
  background: #495057;
}

.footer-placeholder i {
  margin-bottom: 10px;
}

.preview-app-section {
  background: #3a3e81;
  color: white;
  padding: 16px;
  text-align: center;
}

.app-download {
  font-size: 14px;
  font-weight: 500;
}

.config-card {
  background: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  overflow: hidden;
  border: 1px solid #e9ecef;
}

.config-card-header {
  background: #f8f9fa;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
}

.config-card-header h4 {
  margin: 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
}

.config-card-body {
  padding: 20px;
}

.section-description {
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 20px;
  padding: 15px;
  background-color: white;
  border-radius: 6px;
  border-left: 4px solid #3a3e81;
  border: 1px solid #e9ecef;
}

.config-footer {
  background: white;
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-primary {
  background-color: #3a3e81;
  border-color: #3a3e81;
  padding: 8px 20px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
}

.btn-primary:hover {
  background-color: #2e3270;
  border-color: #2e3270;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  padding: 8px 20px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
}

/* Estilos específicos para componentes de radio com imagens - CORRIGIDOS */
.config-card-body :deep(.config-property) {
  margin-bottom: 0;
  padding: 0;
}

.config-card-body :deep(.input-radio) {
  display: block;
  width: 100%;
  cursor: pointer;
  margin-top: 12px;
  border: 2px solid #e9ecef;
  padding: 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
  background: white;
  position: relative;
}

.config-card-body :deep(.input-radio:hover) {
  border-color: #3a3e81;
  box-shadow: 0 2px 8px rgba(58, 62, 129, 0.15);
  transform: translateY(-1px);
}

.config-card-body :deep(.input-radio input[type="radio"]:checked) {
  accent-color: #3a3e81;
}

.config-card-body :deep(.input-radio input[type="radio"]:checked) ~ .row {
  color: #3a3e81;
  font-weight: 600;
}

.config-card-body :deep(.input-radio img) {
  max-width: 100%;
  height: auto;
  max-height: 120px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 12px;
  object-fit: contain;
}

.config-card-body :deep(.input-radio .row) {
  margin: 0;
  align-items: flex-start;
  position: relative;
}

.config-card-body :deep(.input-radio .col-sm-1) {
  flex: 0 0 auto;
  width: auto;
  padding-right: 12px;
  position: relative;
  z-index: 10;
}

.config-card-body :deep(.input-radio .col-sm-11) {
  flex: 1;
  padding-left: 0;
  font-size: 14px;
  line-height: 1.4;
}

.config-card-body :deep(.input-radio input[type="radio"]) {
  width: 18px;
  height: 18px;
  margin: 0;
  position: relative;
  z-index: 20;
}

.config-card-body :deep(.form-control) {
  border-radius: 4px;
  border: 1px solid #ced4da;
  padding: 8px 12px;
  transition: border-color 0.2s ease;
  font-size: 14px;
  margin-top: 8px;
}

.config-card-body :deep(.form-control:focus) {
  border-color: #3a3e81;
  box-shadow: 0 0 0 0.2rem rgba(58, 62, 129, 0.25);
}
</style>
